import { CSS } from '@grupoboticario/flora-react'

export const iconBoxCss: CSS = {
  width: '18px',
  height: '18px'
}

export const largeIconBoxCss: CSS = {
  width: '20px',
  height: '20px'
}

export const cursorPointerCss: CSS = {
  cursor: 'pointer'
}

export const getConditionalCursorCss = (isDisabled: boolean): CSS => ({
  cursor: isDisabled ? undefined : 'pointer'
})
